<template>
  <div>
    <v-card elevation="0" class="pa-4" v-if="!loading">
      <v-row>
        <v-col cols="12" class="ma-0 pa-0 text-right">
          <div v-for="(message ,index) in messages" :key="index">
            <v-row v-if="message.sent_by === 'admin' || message.sent_by === 'instructor'" class="dir-rtl">
              <v-col cols="11" class="text-right mb-0 pb-0">
                <span v-if="message.sent_by === 'instructor'">
                     {{ message.instructor_name }}
                </span>
                <span v-if="message.sent_by === 'admin'">
                     {{ message.admin_name }}
                </span>
                <v-icon v-if="message.attachment_type === 'audio'">mdi-microphone</v-icon>
                <v-icon v-else>mdi-message-reply-outline</v-icon>
              </v-col>
              <v-col cols="12" class="text-right mb-0 pb-0" v-if="message.attachment_type === 'audio'">
                <audio :src="message.url" controls class="chat-audio my-0 py-0"></audio>
              </v-col>
              <v-col cols="12" class="text-right mb-0 pb-0" v-else>
                {{ message.content }}
              </v-col>
              <v-col cols="12" class="text-left my-0 py-0 dateTime-message">
                {{ message.created_at_fa }}
              </v-col>
            </v-row>
            <v-row v-else class="dir-ltr">
              <v-col cols="1">
                <v-btn fab x-small color="error" elevation="1" @click="deleteMessage(message.id)">
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="11" class="text-left mb-0 pb-0">
                {{ message.student_name }}
                <v-icon v-if="message.attachment_type === 'audio'">mdi-microphone</v-icon>
                <v-icon v-else>mdi-message-reply-outline</v-icon>
              </v-col>
              <v-col cols="11" class="text-left mb-0 pb-0" v-if="message.attachment_type === 'audio'">
                <audio :src="message.url" controls class="chat-audio my-0 py-0"></audio>
              </v-col>
              <v-col cols="11" class="text-left mb-0 pb-0" v-else>
                {{ message.content }}
              </v-col>
              <v-col class="text-right my-0 py-0 dateTime-message">
                {{ message.created_at_fa }}
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col :cols="voice ? '4' : '3' ">
          <v-btn class="mr-1 white--text" elevation="0" small fab color="black" @click="sendMessage" :disabled="disableSendButton">
            <v-icon>mdi-send</v-icon>
          </v-btn>
          <v-btn v-if="!recorderInstance && !voice" elevation="0" color="#4770fe" class="mx-1" small fab
                 @click="startRecord">
            <v-icon color="white">mdi-microphone</v-icon>
          </v-btn>
          <v-btn v-if="recorderInstance" elevation="0" small class="mx-1" color="error" fab @click="stopRecord">
            <v-icon>mdi-pause</v-icon>
          </v-btn>
          <v-badge
              v-if="recorderInstance"
              offset-x="-10"
              class="mx-1 v-size--large"
              color="error"
              :content="recordCounter"
          >
          </v-badge>
          <v-btn v-if="voice" @click="deleteVoice" color="error" class="mb-8 mr-1">
            <v-icon color="white">
              mdi-trash-can-outline
            </v-icon>
          </v-btn>
        </v-col>
        <v-col :cols="voice ? '8' : '9'">
          <v-text-field
              v-if="!recorderInstance && !voice"
              v-model="message.content" label="متن را وارد کنید"
              color="#4db6ac"></v-text-field>
          <audio v-if="voice" id="user-voice" controls :src="voice" class="chat-audio">
          </audio>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>

export default {
  name: "LessonChatDesktop",
  props: ['lessonId', 'classId'],
  mounted() {
    this.getMessages()
    this.initialListenWs()
  },
  data() {
    return {
      disableSendButton: false,
      loading: true,
      message: {
        content: null,
        isImportant: false,
        url: null,
        attachment_type: null,
      },
      voice: null,
      recorderInstance: null,
      counterFunction: null,
      messages: null,
      recordCounter: null,
    }
  },
  methods: {
    listenWs(type) {
      if (type === 'immediately') {
        this.$store.state.Echo.private('send.message.' + this.$store.state.user.id)
            .listen('SendMessage', (e) => {
              console.log(e)
              this.getMessages()
            })
      } else {
        let self = this
        window.setTimeout(function () {
          self.$store.state.Echo.private('send.message.' + self.$store.state.user.id)
              .listen('SendMessage', (e) => {
                console.log(e.data.data, 'Sockete yekam ba takhir')
                self.getMessages()
              })
        }, 3000)
      }
    },
    initialListenWs() {
      if (!this.$store.state.user) {
        return
      }
      if (!this.$store.state.loadingEcho) {
        this.listenWs('immediately')
      } else {
        this.listenWs('wait')
      }
    },
    startRecord() {
      this.disableSendButton = true
      navigator.mediaDevices.getUserMedia({audio: true}).then((stream) => {
        this.recorderInstance = new MediaRecorder(stream);
        this.recordCounter = 0
        let self = this
        this.counterFunction = window.setInterval(function () {
          self.recordCounter++
        }, 1000)
        this.recorderInstance.start()
        this.recorderStarted = true
        this.recorderInstance.ondataavailable = (e) => {
          this.voice = `${window.URL.createObjectURL(e.data)}`
          this.uploadFile(e.data)
        };
      })
    },
    stopRecord() {
      this.recorderInstance.stream.getTracks()[0].stop()
      this.recorderInstance.stop()
      this.recordCounter = 0
      window.clearInterval(this.counterFunction);
      this.recorderInstance = null
    },
    deleteVoice() {
      window.clearInterval(this.counterFunction);
      this.recorderInstance = null
      this.voice = null
      this.mime = 'str'
      this.showVoice = false
      this.recorderStarted = false
      this.recorderInstance = null
      this.textStatus = true
      this.showMic = true
      this.message = {
        content: null,
        isImportant: false,
        url: null,
        attachment_type: null,
      }
      this.disableSendButton = false
    },
    // onResult(data) {
    //   this.file = data
    //   this.voice = `${window.URL.createObjectURL(data)}`
    // },
    getMessages() {
      window.axios.get('chat/student/crud/index/' + this.lessonId).then((res) => {
        this.messages = res.data.data
        this.loading = false
      })
    },
    sendMessage() {
      if (!this.message.content && !this.message.url) {
        this.openSnackbar('پیام خالی نمی توانید ارسال کنید.', '#FB4E4E')
        return
      }
      console.log(this.lessonId)
      window.axios.post('/chat/student/crud/create', {
        item_id: this.lessonId,
        online_class_id: this.classId,
        url: this.message.url,
        attachment_type: this.message.attachment_type,
        content: this.message.content,
      }).then(() => {
        this.voice = null
        this.recorderInstance = null
        this.counterFunction = null
        this.recordCounter = null
        this.message = {
          content: null,
          isImportant: false,
          url: null,
          attachment_type: null,
        }
        this.getMessages()
      })
    },
    uploadFile(file) {
      let newData = new FormData
      newData.append('module', 'adminChat')
      newData.append('file', file)
      newData.append('directory', 'chat')
      window.axios.post("file-manager/direct/store", newData).then((res) => {
        this.message.url = res.data.data.data.url
        this.message.attachment_type = 'audio'
        this.loading = false
        this.disableSendButton = false
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#FB4E4E')
        this.loading = false
        this.disableSendButton = false
      })
    },
    deleteMessage(messageId) {
      window.axios.delete('student/chat/delete/' + messageId).then(() => {
        this.getMessages()
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    }
  }
}
</script>

<style scoped>
.dir-ltr {
  margin: 5px;
  direction: ltr !important;
  background-color: #c8e7e4;
  color: black;
  border-radius: 20px;
}

.dateTime-message {
  font-size: 0.6vw;
}

.dir-rtl {
  margin: 5px;
  direction: rtl !important;
  background-color: #d0d9fa;
  color: black;
  border-radius: 20px;
}

.chat-audio {
  width: 100%;
  border-radius: 50px;
  background-color: #5178fe;
}
</style>